import { render, staticRenderFns } from "./SystemTemplates.vue?vue&type=template&id=77b74053&scoped=true"
import script from "./SystemTemplates.vue?vue&type=script&lang=js"
export * from "./SystemTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b74053",
  null
  
)

export default component.exports